import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "data-item" };
const _hoisted_2 = { class: "data-item__header" };
const _hoisted_3 = { class: "data-item__nav" };
const _hoisted_4 = { class: "data-item__topic" };
const _hoisted_5 = { class: "data-item__title" };
const _hoisted_6 = { class: "data-item__meta" };
const _hoisted_7 = { class: "data-item__facts" };
const _hoisted_8 = { class: "data-item__actions" };
const _hoisted_9 = { class: "data-item__content" };
const _hoisted_10 = {
    key: 0,
    class: "data-item__section"
};
const _hoisted_11 = { class: "data-properties data-properties--stacked" };
const _hoisted_12 = {
    key: 0,
    class: "data-properties__property"
};
const _hoisted_13 = { class: "data-properties__label" };
const _hoisted_14 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_15 = { class: "data-properties__property" };
const _hoisted_16 = { class: "data-properties__label" };
const _hoisted_17 = { class: "data-properties__value data-properties__value--emphasized" };
const _hoisted_18 = {
    key: 1,
    class: "data-properties__property"
};
const _hoisted_19 = { class: "data-properties__label" };
const _hoisted_20 = { class: "text-muted" };
const _hoisted_21 = { class: "transfer-options" };
const _hoisted_22 = { class: "transfer-options__nav" };
import { onMounted, ref, watch } from 'vue';
import { useRoute } from "vue-router";
import importProfileRepository from "../services/ShopImportProfileRepository";
import palomaInput from "@astina/paloma-common-ui/src/services/PalomaInput";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import Fact from "@astina/paloma-common-ui/src/components/Fact.vue";
import DeleteShopImportProfile from "../commands/DeleteShopImportProfile";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import DuplicateShopImportProfile from "../commands/DuplicateShopImportProfile";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImportProfileDetailView',
    emits: [
        'close',
        'prev',
        'next'
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const emit = __emit;
        const profile = ref(null);
        const duplicateProfile = ref(null);
        const deleteProfile = ref(null);
        const reportSearchRequest = ref({ filters: [], query: null });
        const transferInformation = ref(null);
        onMounted(() => {
            loadProfile();
            loadTransferInformation();
        });
        watch(() => route.params, loadProfile);
        function loadProfile() {
            const id = RouterUtils.singleParam(route, 'id');
            importProfileRepository
                .get(id)
                .then(profileParam => {
                profile.value = profileParam;
                reportSearchRequest.value.filters = [{
                        attribute: 'process',
                        values: [`import_${profile.value.id}`]
                    }];
                duplicateProfile.value = new DuplicateShopImportProfile(profileParam.id);
                deleteProfile.value = new DeleteShopImportProfile(profileParam.id);
            })
                .catch(() => {
                closeView();
            });
        }
        function loadTransferInformation() {
            palomaInput
                .getTransferInformation()
                .then(data => transferInformation.value = data);
        }
        function closeView() {
            emit('close');
        }
        function prevItem() {
            emit('prev');
        }
        function nextItem() {
            emit('next');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (prevItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-left" })
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (closeView()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "times" })
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (nextItem()), ["prevent"])),
                            class: "data-item__nav-item",
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "angle-right" })
                        ])
                    ]),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    (profile.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('import_profile')), 1),
                            _cache[11] || (_cache[11] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_5, _toDisplayString(profile.value.name), 1),
                            _cache[12] || (_cache[12] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(Fact, {
                                        label: _ctx.$t('created_by'),
                                        value: profile.value.createdBy
                                    }, null, 8, ["label", "value"]),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    _createVNode(Fact, {
                                        label: _ctx.$t('import_profile.status'),
                                        value: profile.value.status,
                                        variant: profile.value.status === 'active' ? 'success' : 'danger'
                                    }, null, 8, ["label", "value", "variant"]),
                                    _cache[7] || (_cache[7] = _createTextVNode()),
                                    (profile.value._meta?.template?.info.label)
                                        ? (_openBlock(), _createBlock(Fact, {
                                            key: 0,
                                            label: _ctx.$t('import_profile.template'),
                                            value: profile.value._meta?.template?.info.label
                                        }, null, 8, ["label", "value"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_8, [
                                    (duplicateProfile.value)
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 0,
                                            command: duplicateProfile.value,
                                            label: "",
                                            classes: ['button', 'button--icon', 'button--outline']
                                        }, null, 8, ["command"]))
                                        : _createCommentVNode("", true),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    _createVNode(_component_router_link, {
                                        to: { name: 'integration_import_edit', params: { id: profile.value.id } },
                                        class: "button button--icon"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(Icon, { name: "pencil" })
                                        ]),
                                        _: 1
                                    }, 8, ["to"]),
                                    _cache[9] || (_cache[9] = _createTextVNode()),
                                    (deleteProfile.value)
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 1,
                                            command: deleteProfile.value,
                                            onSuccess: _cache[3] || (_cache[3] = ($event) => (closeView())),
                                            label: "",
                                            classes: ['button', 'button--icon', 'button--danger']
                                        }, null, 8, ["command"]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !profile.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[24] || (_cache[24] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    (profile.value)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                (profile.value.template)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('import_profile.template')), 1),
                                        _cache[14] || (_cache[14] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_14, _toDisplayString(profile.value._meta?.template?.info.label), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[21] || (_cache[21] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('import_profile.reader')), 1),
                                    _cache[15] || (_cache[15] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_17, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.value._meta?.consumes, (format) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                _createTextVNode(_toDisplayString(format.localizedName), 1)
                                            ], 64));
                                        }), 256))
                                    ])
                                ]),
                                _cache[22] || (_cache[22] = _createTextVNode()),
                                _createVNode(Spinner, {
                                    loading: !transferInformation.value
                                }, null, 8, ["loading"]),
                                _cache[23] || (_cache[23] = _createTextVNode()),
                                (transferInformation.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('import_profile.transfer')), 1),
                                        _cache[19] || (_cache[19] = _createTextVNode()),
                                        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('import_profile.transfer_info')), 1),
                                        _cache[20] || (_cache[20] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("nav", _hoisted_22, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'integration_import_transfer_sftp' },
                                                    class: "button button--outline"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('import_profile.transfer.sftp')), 1)
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[16] || (_cache[16] = _createTextVNode()),
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'integration_import_transfer_http' },
                                                    class: "button button--outline"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('import_profile.transfer.http')), 1)
                                                    ]),
                                                    _: 1
                                                }),
                                                _cache[17] || (_cache[17] = _createTextVNode()),
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'integration_import_transfer_upload' },
                                                    class: "button button--outline"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('import_profile.transfer.upload')), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _cache[18] || (_cache[18] = _createTextVNode()),
                                            _createVNode(_component_router_view, {
                                                profile: profile.value,
                                                "transfer-information": transferInformation.value
                                            }, null, 8, ["profile", "transfer-information"])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
